import {
  FinancingCompositionLayer,
  FinancingCompositionScene,
  CompositionTextLayer,
} from '@dms/api/shared';

import {createRectLayer} from './createRectLayer';
import {createTextLayer} from './createTextLayer';

const BADGE_PADDING = 16;

// A badge is a rect with a text on top; the scene has no group concept. The text box fills the rect
// inside the padding and centres the text vertically, so wrapped text stays visible.
export const createBadgeLayers = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>,
  text: string
): FinancingCompositionLayer[] => {
  const rect = createRectLayer(canvas);
  const textLayer: CompositionTextLayer = {
    ...createTextLayer(canvas, text),
    x: rect.x + BADGE_PADDING,
    y: rect.y + BADGE_PADDING,
    width: rect.width - 2 * BADGE_PADDING,
    height: rect.height - 2 * BADGE_PADDING,
    verticalAlign: 'middle',
  };
  return [rect, textLayer];
};
